import {useReducerWithMiddleware} from "../hooks/useReducerWithMiddleware";
import APIData from "../context/APIData";
import {rootReducer, initialState} from "../reducers/rootReducer";
import {logger} from "../middleware/logger";

export const APIDataProvider = ({children}) => {
    const [state, dispatch] = useReducerWithMiddleware(rootReducer,initialState,[logger])
    return (<APIData.Provider value={{...state, dispatch}}>
        {children}
    </APIData.Provider>)
}